import toastr from "toastr";
import "toastr/build/toastr.css";

export default toastr;
